import { useTinyHost } from "@tiny/host-contract";
import React from "react";
import { Paginator, Box, EmptyState } from "@tiny/components";
import TrafficShapingFilter from "./TrafficShapingFilter";
import { TrafficShapingProvider } from "./TrafficShapingList.context";
import { useTrafficShaping } from "./TrafficShapingList.hooks";
import { TrafficShapingProps } from "./TrafficShapingList.types";
import { useStyles } from "./TrafficShapingList.styles";
import TrafficShapingRow from "./TrafficShapingRow";
import Search from "@tiny/icons/generated/Search";
import ComponentLoader from "@tiny/components/src/ComponentLoader/ComponentLoader";
import AITrafficSegmentDetailsDialog from "../AITrafficSegmentDetailsDialog";

function TrafficShapingList(props: TrafficShapingProps) {
  const { slots } = useTinyHost();
  const trafficShapingView = useTrafficShaping(props);

  const classes = useStyles();

  const {
    ai_traffic_items,
    boxProps,
    itemsPerPage,
    itemsPerPageOptions,
    isEmpty,
    isAITrafficShappingLoading,
    onPageChange,
    selected: selectedAudience,
    onItemsPerPageChange,
    page,
    visible,
    showTrafficShapingDialog,
    closeTrafficShapingDialog,
    reloadAITrafficShapingItems,
    showAITrafficControlDetailsDialog,
    closeAITrafficControlDetailsDialog,
    openTrafficShapingDialog,
    selectedTrafficControlId,
  } = trafficShapingView;

  if (!visible) {
    return null;
  }

  return (
    <>
      <TrafficShapingProvider value={trafficShapingView}>
        <Box {...boxProps}>
          <TrafficShapingFilter
            onAITrafficShapingClick={openTrafficShapingDialog}
          />
          {isAITrafficShappingLoading ? (
            <ComponentLoader height="400px" />
          ) : isEmpty ? (
            <Box bgcolor="grey.50" pt={10} pb={10}>
              <EmptyState
                title="No audiences found"
                message="Try some other search keywords. Tip: Try remembering the audience name"
                icon={<Search />}
                iconColor="primary"
                circleColor="white"
                align="center"
              />
            </Box>
          ) : (
            <ul className={classes.list}>
              {ai_traffic_items?.content?.map((ai_item) => (
                <TrafficShapingRow
                  key={ai_item.id}
                  ai_traffic_shaping_item={ai_item}
                />
              ))}
            </ul>
          )}
          <Paginator
            mt={4}
            itemsPerPageOptions={itemsPerPageOptions}
            page={page}
            itemsPerPage={itemsPerPage}
            totalCount={ai_traffic_items?.totalElements}
            onPageChange={onPageChange}
            onItemsPerPageChange={onItemsPerPageChange}
            itemsPerPageLabel="Results"
          />
        </Box>

        {showTrafficShapingDialog &&
          slots?.trafficControlWizardDialog?.({
            open: showTrafficShapingDialog,
            onClose: closeTrafficShapingDialog,
            onSuccess: () => {
              reloadAITrafficShapingItems();
            },
          })}

        {showAITrafficControlDetailsDialog && (
          <AITrafficSegmentDetailsDialog
            onClose={closeAITrafficControlDetailsDialog}
            open={showAITrafficControlDetailsDialog}
            aiTrafficControlId={selectedTrafficControlId}
          />
        )}
      </TrafficShapingProvider>
    </>
  );
}

export default TrafficShapingList;
